import * as React from 'react';
import moment from 'moment';
import 'moment/locale/th';

import { Table, TableHead, TableCell, TableRow, TableBody, Card, CardHeader, CardContent } from '@mui/material';

export default function CommissionHistory(props) {
  const data = props.data;

  return (
    <Card>
      <CardHeader title='Comission History' />
      <CardContent>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>date</TableCell>
              <TableCell>commision</TableCell>
              <TableCell>equity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data ? (
              data.map((row) => (
                <TableRow key={row.reportLineId}>
                  <TableCell>{moment(row.created_date).format('ll')}</TableCell>
                  <TableCell>{row.totalCommission}</TableCell>
                  <TableCell>{row.currentEquity}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align='center'>
                  No data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
